// extracted by mini-css-extract-plugin
export default {"iconsContainer":"n39y5iro","desktop":"desktop","mobile":"mobile","icon":"rDpgcook"};